'use strict';

const Tier1CategoryIds = {
    ArtsEntertainment: 1,
    Automotive: 2,
    Business: 3,
    Demographics: 4,
    DeviceAttributes: 5,
    Finance: 6,
    Lifestyle: 7,
    Travel: 8,
    HealthMedicine: 9,
    Sports: 10,
    Technology: 11,
    HomeGarden: 12,
    Shopping: 13,
    DiningOut: 14,
    DiningIn: 15,
};

const Tier1Categories = [
    { id: Tier1CategoryIds.ArtsEntertainment, name: 'Arts & Entertainment' },
    { id: Tier1CategoryIds.Automotive, name: 'Automotive' },
    { id: Tier1CategoryIds.Business, name: 'Business' },
    { id: Tier1CategoryIds.Demographics, name: 'Demographics' },
    { id: Tier1CategoryIds.DeviceAttributes, name: 'Device Attributes' },
    { id: Tier1CategoryIds.Finance, name: 'Finance' },
    { id: Tier1CategoryIds.Lifestyle, name: 'Lifestyle' },
    { id: Tier1CategoryIds.Travel, name: 'Travel' },
    { id: Tier1CategoryIds.HealthMedicine, name: 'Health & Medicine' },
    { id: Tier1CategoryIds.Sports, name: 'Sports' },
    { id: Tier1CategoryIds.Technology, name: 'Technology' },
    { id: Tier1CategoryIds.HomeGarden, name: 'Home & Garden' },
    { id: Tier1CategoryIds.Shopping, name: 'Shopping' },
    { id: Tier1CategoryIds.DiningIn, name: 'Dining In' },
    { id: Tier1CategoryIds.DiningOut, name: 'Dining Out' },
];

let Tier1Lookup = null;
function getTier1Lookup() {
    if (!Tier1Lookup) {
        const lookup = {};
        Tier1Categories.forEach(function (category) {
            lookup[category.id] = category;
        });
        Tier1Lookup = lookup;
    }
    return Tier1Lookup;
}

// Datasources represent where the data comes from

// Left hand side values should never be renamed as they are embedded in code
// Right hand side values should never be renamed as they are used to key other collections
// These should never show up in display so they should not need to be changed as far as
// capitalization, etc.  If you need to display something use Datasources NOT DatasourceIds
const DatasourceIds = {
    Pushspring: 'pushspring',
    Pinsight: 'pinsight',
    Cuebiq: 'cuebiq',
    Placecast: 'placecast',
    V12: 'v12',
    SMS: 'sms',
    Bombora: 'bombora',
    Stirista: 'stirista',
    PlaceIQ: 'placeiq',
    Ameribase: 'ameribase',
    Scanbuy: 'scanbuy',
    Gravy: 'gravy',
    Test: 'test',
    Tivo: 'tivo',
    IRI: 'iri',
    OneEightyByTwo: 'oneeightybytwo',
    Clickagy: 'clickagy',
    Alliant: 'alliant',
    RevealMobile: 'revealmobile',
    Epsilon: 'epsilon',
    ASLMarketing: 'aslmarketing',
    ShareThis: 'sharethis',
    NinthDecimal: 'ninthdecimal',
    AnalyticsIQ: 'analyticsiq',
    LOCALLY: 'locally',
    AffinityAnswers: 'affinityanswers',
    AffinitySolutions: 'affinitysolutions',
    MeritDirect: 'meritdirect',
    StatSocial: 'statsocial',
    Skyhook: 'skyhook',
    Audigent: 'audigent',
    CrossPixel: 'crosspixel',
    PeerLogix: 'peerlogix',
    Webbula: 'webbula',
    Claritas: 'claritas',
    ThirtyThreeAcross: 'thirtythreeacross',
    DishTV: 'dishtv',
    Insticator: 'insticator',
    Adstra: 'adstra',
    Xmode: 'xmode',
    Bridge: 'bridge',
    Dstillery: 'dstillery',
    OneEightyByTwoDirect: 'oneeightybytwodirect',
    Wiland: 'wiland',
    Reklaim: 'reklaim',
    Equifax: 'equifax',
    DataAxle: 'dataaxle',
    Fyllo: 'fyllo',
    TMobileDataEngineering: 'tmobiledataengineering',
    Catalina: 'catalina',
    Foursquare: 'foursquare',
    InMarket: 'inmarket',
    AmeriLink: 'amerilink', // Wunderman
    TivoBDEX: 'tivobdex',
    PlaceIQDirect: 'placeiqdirect',
    StartIO: 'startio',
    AnalyticsIQDirect: 'analyticsiqdirect',
    IHSMarkitPolk: 'ihsmarkitpolk',
    Comscore: 'comscore',
    CIS: 'cis',
    Homedata: 'homedata',
    SambaTV: 'sambatv',
    Loopme: 'loopme',
    DeepSync: 'deepsync',
    Sliide: 'sliide',
    Unity: 'unity',
};

const Datasources = [
    { id: DatasourceIds.DeepSync, name: 'Deep Sync' },
    { id: DatasourceIds.Pushspring, name: 'T-Mobile Mobility Data' },
    { id: DatasourceIds.Pinsight, name: 'Pinsight', hidden: true },
    { id: DatasourceIds.Cuebiq, name: 'Cuebiq', hidden: true },
    { id: DatasourceIds.Placecast, name: 'Placecast', hidden: true },
    { id: DatasourceIds.V12, name: 'V12' },
    { id: DatasourceIds.SMS, name: 'SMS' },
    { id: DatasourceIds.Bombora, name: 'Bombora' },
    { id: DatasourceIds.Stirista, name: 'Stirista' },
    { id: DatasourceIds.PlaceIQ, name: 'PlaceIQ', hidden: true },
    { id: DatasourceIds.Ameribase, name: 'Ameribase Digital' },
    { id: DatasourceIds.Scanbuy, name: 'Scanbuy', hidden: true },
    { id: DatasourceIds.Gravy, name: 'Gravy', hidden: true },
    { id: DatasourceIds.Test, name: 'Test', hidden: true },
    { id: DatasourceIds.Tivo, name: 'TiVo', hidden: true },
    { id: DatasourceIds.IRI, name: 'IRI' },
    { id: DatasourceIds.Clickagy, name: 'Clickagy' },
    { id: DatasourceIds.OneEightyByTwo, name: '180byTwo' },
    { id: DatasourceIds.Alliant, name: 'Alliant' },
    { id: DatasourceIds.RevealMobile, name: 'Reveal Mobile', hidden: true },
    { id: DatasourceIds.Epsilon, name: 'Epsilon' },
    { id: DatasourceIds.ASLMarketing, name: 'ASL Marketing', hidden: true },
    { id: DatasourceIds.ShareThis, name: 'ShareThis' },
    { id: DatasourceIds.NinthDecimal, name: 'NinthDecimal', hidden: true },
    { id: DatasourceIds.AnalyticsIQ, name: 'AnalyticsIQ' },
    { id: DatasourceIds.LOCALLY, name: 'LOCALLY', hidden: true },
    { id: DatasourceIds.AffinityAnswers, name: 'Affinity Answers' },
    { id: DatasourceIds.AffinitySolutions, name: 'Affinity Solutions' },
    { id: DatasourceIds.MeritDirect, name: 'MeritDirect', hidden: true },
    { id: DatasourceIds.StatSocial, name: 'StatSocial', hidden: true },
    { id: DatasourceIds.Skyhook, name: 'Skyhook', hidden: true },
    { id: DatasourceIds.Audigent, name: 'Audigent', hidden: true },
    { id: DatasourceIds.CrossPixel, name: 'Cross Pixel' },
    { id: DatasourceIds.PeerLogix, name: 'PeerLogix', hidden: true },
    { id: DatasourceIds.Webbula, name: 'Webbula' },
    { id: DatasourceIds.Claritas, name: 'Claritas' },
    { id: DatasourceIds.ThirtyThreeAcross, name: '33Across' },
    { id: DatasourceIds.DishTV, name: 'Dish TV', hidden: true },
    { id: DatasourceIds.Insticator, name: 'Insticator', hidden: true },
    { id: DatasourceIds.Adstra, name: 'Adstra' },
    { id: DatasourceIds.Xmode, name: 'X-Mode', hidden: true },
    { id: DatasourceIds.Bridge, name: 'Bridge', hidden: true },
    { id: DatasourceIds.Dstillery, name: 'Dstillery' },
    { id: DatasourceIds.OneEightyByTwoDirect, name: '180byTwo', hidden: true },
    { id: DatasourceIds.Wiland, name: 'Wiland' },
    { id: DatasourceIds.Reklaim, name: 'Reklaim', hidden: true },
    { id: DatasourceIds.Equifax, name: 'Equifax' },
    { id: DatasourceIds.DataAxle, name: 'Data Axle' },
    { id: DatasourceIds.Fyllo, name: 'Fyllo' },
    { id: DatasourceIds.TMobileDataEngineering, name: 'T-Mobile Data Engineering', hidden: true },
    { id: DatasourceIds.Catalina, name: 'Catalina', hidden: true },
    { id: DatasourceIds.Foursquare, name: 'Foursquare' },
    { id: DatasourceIds.InMarket, name: 'InMarket', hidden: true },
    { id: DatasourceIds.AmeriLink, name: 'AmeriLink', hidden: true },
    { id: DatasourceIds.TivoBDEX, name: 'Tivo/BDEX' },
    { id: DatasourceIds.PlaceIQDirect, name: 'PlaceIQ' },
    { id: DatasourceIds.StartIO, name: 'Start.io' },
    { id: DatasourceIds.AnalyticsIQDirect, name: 'AnalyticsIQ', hidden: true },
    { id: DatasourceIds.IHSMarkitPolk, name: 'Polk Audiences by S&P Global Mobility' },
    { id: DatasourceIds.Comscore, name: 'Comscore', hidden: true },
    { id: DatasourceIds.CIS, name: 'CIS', hidden: true },
    { id: DatasourceIds.Homedata, name: 'Homedata', hidden: true },
    { id: DatasourceIds.SambaTV, name: 'Samba TV', hidden: true },
    { id: DatasourceIds.Loopme, name: 'Loopme' },
    { id: DatasourceIds.Sliide, name: 'Sliide' },
    { id: DatasourceIds.Unity, name: 'Unity' },
];

let DatasourceLookup = null;
function getDatasourceLookup() {
    if (!DatasourceLookup) {
        const lookup = {};
        Datasources.forEach(function (datasource) {
            lookup[datasource.id] = datasource;
        });
        DatasourceLookup = lookup;
    }
    return DatasourceLookup;
}

// Datatypes represent how the item was derived
const DataTypeIds = {
    AppEngagementPersonas: 'appengagementpersonas',
    AppOwnership: 'appownership',
    Personas: 'personas',
    Demographics: 'demographics',
    Location: 'location',
    Behavioral: 'behavioral',
    DeviceAttributes: 'deviceattributes',
    Auto: 'auto',
    Political: 'political',
    TV: 'tv',
    B2B: 'b2b',
    Purchase: 'purchase',
    Social: 'social',
    Weather: 'weather',
    AppEngagementApps: 'appengagementapps',
    AppGraphPlus: 'appgraphplus', // Only a psuedo type for combined details pages. Don't assign to real attributes
};

/**
 * @typedef DataType
 * @property {String} id - Related DataTypeId.
 * @property {String} name - Human-readable name. Used for display.
 * @property {boolean} hidden - Is displayed on UI?
 * @property {boolean} hasLandingPage - Does this DataType require a special landing page?
 * @property {boolean} hasAppGraphPlus - Is this an AppGraph+ DataType?
 * @property {boolean} isNew - Controls the 'New' flag on the UI.
 * @property {boolean} minBetaLevel - Minimum beta level required to see this DataType.
 */

const DataTypes = [
    {
        id: DataTypeIds.AppEngagementPersonas,
        name: 'Engagement Personas',
        hidden: false,
        hasLandingPage: true,
        hasAppGraphPlus: true,
        isNew: false,
    },
    { id: DataTypeIds.AppOwnership, name: 'App Ownership', hasAppGraph: true },
    { id: DataTypeIds.Personas, name: 'Ownership Personas', hasLandingPage: true, hasAppGraph: true },
    { id: DataTypeIds.Demographics, name: 'Demographics', hasLandingPage: true },
    { id: DataTypeIds.Location, name: 'Location', hasLandingPage: true },
    { id: DataTypeIds.Behavioral, name: 'Behavioral', hasLandingPage: true },
    { id: DataTypeIds.DeviceAttributes, name: 'Device Attributes', hasLandingPage: true },
    { id: DataTypeIds.Auto, name: 'Auto', hidden: false, hasLandingPage: true },
    { id: DataTypeIds.Political, name: 'Political', hidden: false, hasLandingPage: true },
    { id: DataTypeIds.TV, name: 'TV Viewership', hidden: true, hasLandingPage: true },
    { id: DataTypeIds.B2B, name: 'B2B', hidden: false, hasLandingPage: true },
    { id: DataTypeIds.Purchase, name: 'Purchase', hidden: false, hasLandingPage: true },
    { id: DataTypeIds.Social, name: 'Social', hidden: true, hasLandingPage: true },
    { id: DataTypeIds.Weather, name: 'Weather', hidden: true },
    {
        id: DataTypeIds.AppEngagementApps,
        name: 'App Engagement',
        hidden: false,
        isNew: true,
        hasAppGraphPlus: true,
    },
    {
        // Only a psuedo type for combined details pages. Don't assign to real attributes
        id: DataTypeIds.AppGraphPlus,
        name: 'AppGraph+',
        hidden: true,
        hasLandingPage: true,
    },
];

let DataTypeLookup = null;
function getDataTypeLookup() {
    if (!DataTypeLookup) {
        const lookup = {};
        DataTypes.forEach(function (dataType) {
            lookup[dataType.id] = dataType;
        });
        DataTypeLookup = lookup;
    }
    return DataTypeLookup;
}

/**
 * Enum for supported search domains(indexes).
 * Intended to be generic and hide specific infrastructure details.
 * @readonly
 * @enum {number}
 */
const SearchDomain = {
    Production: 0,
    Alternative: 1,
};

const MarketplaceConstants = {
    Propensity: {
        1: 'Inferred intent and interests based on the combination of actual apps installed on and attributes of each device.',
        2: 'Modeled demographic attributes based on actual apps installed on each device.',
        // Ameribase
        3: 'Inferred interest and intent based on deterministic online browsing behaviors and keywords.',
        // IRI
        4: 'People with a high propensity to purchase CPG products, modeled from deterministic purchase data from the National Consumer Panel and scored against 126MM Experian ConsumerView households.',
        5: 'Inferred based on past purchase history patterns',
        // Pinsight
        6: "Inferred intent and interests derived from deterministic mobile web and app behavior, blended with a consumer's physical journey.",
        7: 'Derived based on verified mobile carrier account billing information.',
        // SMS
        8: 'Inferred based on verified and deterministic survey, response, transactional, new mover, public record and warranties.',
        9: 'Derived based on a combination of self-reported and census data and other public data. ',
        // V12
        10: 'Predicted based on event shopping data and actual sales records.',
        11: 'Derived based on a combination of self-reported survey data and other public, household data.',
        // Stirista
        12: 'Inferred interest and intent based on precise postal data, opt-in emails, social media activity combined with extensive demographic, auto, transactional behavioral data.',
        13: 'Inferred from multiple online and offline data sources such as magazines, surveys, subscription services.',
        // Clickagy
        14: 'Interest and intent predicted with advanced natural language processing of online browsing behaviors and keyword analysis of consumed  content.',
        // Bombora
        15: 'Inferred intent and interest based on deterministic B2B research activities and content consumption events.',
        // Gravy
        16: 'Inferred interest and intent based on physical visitation patterns collected via mobile location data.',
        // Alliant
        17: 'Reach buyers who exhibit the same purchase behaviors, derived from a combination of ecommerce receipt data and transactional purchase data to find like buyers at scale.',
        // 180byTwo
        18: 'Inferred interest and intent based on deterministic online browsing behaviors.',
        // Epsilon
        19: "Inferred behaviors and interests based on subscriptions and survey responses from the largest consumer survey in North America (Shopper's Voice).",
        // AnalyticsIQ
        20: 'Derived and modeled using a proprietary predictive model that leverages opt-in survey responses, US census, public records, geo-level econometric data, and transaction data.',
        //
        21: 'Inferred interest based on social sharing activity, searched page visits and click-backs on shared pages.',
        22: 'Statistically modeled with data science, using partner demographic signals.',
        23: "Derived from census data and overlayed with NinthDecimal's location graph.",
        24: "Derived based on people's over-indexed affinity towards specific brands using public, anonymized social interactions from platforms like Instagram, Facebook, and Twitter.",
        25: 'Scored based on >3 years of individual debit and credit transactions using analytics, machine learning, and proprietary algorithms to identify behaviors signaling the highest propensity to purchase in the near future.',
        26: 'Inferred based on keyword based search activity across publisher web sites.',
        27: 'Derived based on show titles of viewed digital content, census information and validated via reverse geolocation.',
        28: "Derived based on content consumption data sourced directly from the world's largest record labels, influencers, and content publishers.",
        29: 'Derived demographic insights based on census block groups. A proprietary homing algorithm is used to assign devices into the appropriate census block groups.',
        30: 'Inferred consumer intent, interests, bevahiors and purchase intent based on data sourced from online browsing behaviors obtained from over 1 million publishers.',
        31: 'Inferred demographic and firmographic attributes based on offline B2B publisher partner data.',
        32: 'Inferred demographic attributes based on offline B2C publisher partner data.',
    },
    // Keep lowercase and lower the input fields during testing/filtering.
    // Old list 'lgbt', 'lesbian', 'gay', 'bisexual', 'transgender', 'transsexual', 'queer', 'homosexual'
    BlacklistedSearchTerms: [],

    Tier1CategoryIds: Tier1CategoryIds,
    Tier1Categories: Tier1Categories,
    DatasourceIds: DatasourceIds,
    Datasources: Datasources,
    DataTypeIds: DataTypeIds,
    DataTypes: DataTypes,
    SearchDomain: SearchDomain,

    Types: {
        Folder: 'folder',
        PartnerAttribute: 'partner_attribute',
        App: 'app',
        Persona: 'persona',
        Partner: 'partner',
    },
};

// Statically analyzable named exports. Rollup / esbuild extract each key of
// the object literal as a named export. The three lookups (Tier1Lookup,
// DatasourceLookup, DataTypeLookup) were previously lazy getters defined via
// Object.defineProperty; they're now computed eagerly at module load. The
// getter functions are memoized internally so re-invocation is cheap.
module.exports = {
    Propensity: MarketplaceConstants.Propensity,
    BlacklistedSearchTerms: MarketplaceConstants.BlacklistedSearchTerms,
    Tier1CategoryIds: MarketplaceConstants.Tier1CategoryIds,
    Tier1Categories: MarketplaceConstants.Tier1Categories,
    DatasourceIds: MarketplaceConstants.DatasourceIds,
    Datasources: MarketplaceConstants.Datasources,
    DataTypeIds: MarketplaceConstants.DataTypeIds,
    DataTypes: MarketplaceConstants.DataTypes,
    SearchDomain: MarketplaceConstants.SearchDomain,
    Types: MarketplaceConstants.Types,
    Tier1Lookup: getTier1Lookup(),
    DatasourceLookup: getDatasourceLookup(),
    DataTypeLookup: getDataTypeLookup(),
};
